<template>
  <div class="main-custom">
    <Header />
    <div id="printable" class="container">
      <span class="spacing-ml-30 has-text-grey no-print">
        <span class="is-clickable" @click="goRoot">{{
          App.Breadcrumb.START
        }}</span>
        / {{ Home.DOC_LESGILATION_GOV }}</span
      >

      <span
        class="is-size-4 has-text-weight-bold spacing-ml-30 spacing-my-20 has-text-blue-oil"
        >{{ Home.DOC_LESGILATION_GOV }}</span
      >

      <div class="level spacing-mx-30 has-text-left header-label">
        <span></span>
        <div class="level-left icons-margin spacing-p-5 spacing-mr-10">
          <span class="spacing-mx-10 has-text-grey is-align-self-center">
            {{ General.PARTICIPATE }}:
          </span>
          <b-icon icon="facebook" class="is-clickable" type="is-grey" />
          <b-icon icon="twitter" class="is-clickable" type="is-grey" />
          <b-icon icon="whatsapp" class="is-clickable" type="is-grey" />
          <b-icon icon="link-variant" class="is-clickable" type="is-grey" />
          <span
            class="is-size-5 has-text-weight-normal mx-10 has-text-grey-light"
            >|</span
          >
          <b-icon
            icon="printer"
            class="is-clickable"
            type="is-grey"
            @click.native="printScreen"
          />
        </div>
      </div>

      <section class="law-list spacing-mx-50">
        <b-loading :isFullPage="false" :active="isLoading" />
        <div
          v-for="(doc, indice) in getLawGov"
          :key="indice"
          class="spacing-px-20 spacing-mb-15"
        >
          <h1
            class="is-size-5 has-text-weight-bold spacing-mb-10 has-text-primary"
          >
            {{ doc.title }}
          </h1>
          <span class="is-size-5 has-text-weight-normal">
            {{ doc.type }}
          </span>
          <p class="spacing-mt-5">
            <a
              class="has-text-weight-normal has-text-primary is-align-self-center"
              :href="sanitizedHtml(doc.url)"
            >
              <b-icon class="custom-height" icon="magnify" />
              <span class="is-size-5">{{ General.TO_VIEW }}</span>
            </a>
          </p>
        </div>
      </section>
    </div>
    <Footer :isReduced="true" />
  </div>
</template>

<script>
import Header from "@/layout/Header";
import Footer from "@/layout/Footer";

import { General, Home, App } from "@/utils/constants";
import { sanitizedHtml } from "@/utils/dataManipulation";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DigitalGOV",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      General,
      Home,
      App,
      sanitizedHtml,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      getLawGov: "getLawGov"
    })
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getLawGovList();
    this.isLoading = false;
  },
  methods: {
    ...mapActions({
      getLawGovList: "getLawGovList"
    }),

    printScreen() {
      const printableHtml = document.getElementById("printable").innerHTML;

      let printableStyles = "";
      [...document.querySelectorAll("link[rel='stylesheet'], style")].forEach(
        element => {
          printableStyles += element.outerHTML;
        }
      );

      const printableWindow = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      printableWindow.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${printableStyles}
        </head>
        <body>
          ${printableHtml}
        </body>
      </html>`);

      printableWindow.document.close();
      printableWindow.focus();
      printableWindow.print();
    },

    goRoot() {
      this.$router.replace("/");
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 90%;
  padding: 15px 0;
  min-height: 400px;

  .law-list {
    position: relative;
  }
}
.header-label {
  background-color: var(--app-background-color);
  align-items: center;
}
.level {
  border-radius: 15px !important;
}
.custom-height {
  height: auto;
}
.icon {
  margin-right: 0.75rem;
}

@media print {
  .no-print {
    display: none;
  }

  @page {
    margin: 0;
  }
}
</style>
